import type { ReactElement } from 'react';

import { GatedChrome, RestrictedPanel } from '@/components/auth/GatedChrome';
import { PermissionErrorPanel } from '@/components/auth/PermissionErrorPanel';
import { BackLink } from '@/components/layout/BackLink';
import type { PermissionState } from '@/hooks/usePermission';
import { TO_PANEL } from '@/lib/back-nav';
import { skeletonLine } from '@/components/ui/skeleton';

// Lista Maestra sin acceso confirmado (G4, cierre F1, nota de QA FUN-06): ni las migas,
// ni el encabezado, ni el aviso nombran la pantalla. `denied` cubre también el 403 del
// backend (acceso temporal vencido): no se ofrece un reintento que nunca funcionaría.

export function MasterListGate({
  state,
  error,
  onRetry,
  retrying,
}: {
  state: Exclude<PermissionState, 'granted'>;
  error: unknown;
  onRetry: () => void;
  retrying: boolean;
}): ReactElement {
  return (
    <>
      <GatedChrome state={state} breadcrumb={[]} navContext="" />
      <BackLink target={TO_PANEL} />
      {state === 'denied' && <RestrictedPanel />}
      {state === 'error' && (
        <PermissionErrorPanel error={error} onRetry={onRetry} retrying={retrying} />
      )}
      {state === 'loading' && (
        <div className="card rise d1" aria-busy="true">
          <span className="sr-only">Cargando</span>
          <div className="cb">
            <span className={skeletonLine({ width: 40 })} />
            <span className={skeletonLine({ width: 70 })} />
            <span className={skeletonLine({ width: 60 })} />
          </div>
        </div>
      )}
    </>
  );
}
